import { ICON_COLOR_VAR_NAME, heightsSizeMap } from "../components/common/Common.js";
import { alpha } from "./utils.js";
const buttonMuiThemeOverride = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const paletteColor = theme.palette[ownerState.color];
      return {
        fontSize: "14px",
        lineHeight: "18px",
        textTransform: "initial",
        boxShadow: "none",
        transition: "none",
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        fontWeight: 500,
        [ICON_COLOR_VAR_NAME]: "white",
        "&:hover, &:focus-visible": {
          boxShadow: "none"
        },
        ".MuiButton-startIcon, .MuiButton-endIcon": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        [theme.breakpoints.down("lg")]: {
          "&.MuiButton-text": {
            minWidth: "auto"
          }
        },
        ...ownerState.variant === "text" && {
          "&:hover": {
            background: "transparent"
          },
          "&.Mui-disabled": {
            color: theme.palette.grey[400],
            [ICON_COLOR_VAR_NAME]: theme.palette.grey[400]
          },
          [ICON_COLOR_VAR_NAME]: paletteColor == null ? void 0 : paletteColor.main,
          "@media (hover: hover)": {
            "&:hover": {
              color: paletteColor == null ? void 0 : paletteColor.light,
              [ICON_COLOR_VAR_NAME]: paletteColor == null ? void 0 : paletteColor.light
            }
          },
          "&:active, &:focus-visible": {
            color: paletteColor == null ? void 0 : paletteColor.dark,
            [ICON_COLOR_VAR_NAME]: paletteColor == null ? void 0 : paletteColor.dark
          }
        },
        ...ownerState.variant === "outlined" && {
          color: paletteColor == null ? void 0 : paletteColor.main,
          borderColor: paletteColor == null ? void 0 : paletteColor.main,
          [ICON_COLOR_VAR_NAME]: paletteColor == null ? void 0 : paletteColor.main,
          "&.Mui-disabled": {
            color: theme.palette.grey[400],
            borderColor: theme.palette.grey[400],
            [ICON_COLOR_VAR_NAME]: theme.palette.grey[400]
          },
          "@media (hover: hover)": {
            "&:hover": {
              color: paletteColor == null ? void 0 : paletteColor.light,
              borderColor: paletteColor == null ? void 0 : paletteColor.light,
              [ICON_COLOR_VAR_NAME]: paletteColor == null ? void 0 : paletteColor.light,
              background: "transparent"
            }
          },
          "&:active, &:focus-visible": {
            color: paletteColor == null ? void 0 : paletteColor.dark,
            borderColor: paletteColor == null ? void 0 : paletteColor.dark,
            [ICON_COLOR_VAR_NAME]: paletteColor == null ? void 0 : paletteColor.dark
          },
          ...ownerState.color === "white" && {
            color: "white",
            "@media (hover: hover)": {
              "&:hover": {
                color: theme.palette.grey[100],
                borderColor: theme.palette.grey[100],
                [ICON_COLOR_VAR_NAME]: theme.palette.grey[100]
              }
            },
            "&:active, &:focus-visible": {
              color: theme.palette.grey[200],
              borderColor: theme.palette.grey[200],
              [ICON_COLOR_VAR_NAME]: theme.palette.grey[200]
            },
            [ICON_COLOR_VAR_NAME]: "white"
          }
        },
        ...ownerState.variant === "contained" && {
          "&.Mui-disabled": {
            color: theme.palette.grey[400],
            [ICON_COLOR_VAR_NAME]: theme.palette.grey[400],
            background: theme.palette.grey[200]
          },
          ...ownerState.color === "primary" && {
            "@media (hover: hover)": {
              "&:hover": {
                background: theme.palette.primary.light,
                boxShadow: "none"
              }
            },
            "&:active, &:focus-visible": {
              background: theme.palette.primary.dark
            }
          },
          ...ownerState.color === "secondary" && {
            "@media (hover: hover)": {
              "&:hover": {
                background: theme.palette.secondary.light,
                boxShadow: "none"
              }
            },
            "&:active, &:focus-visible": {
              background: theme.palette.secondary.dark
            }
          },
          ...ownerState.color === "white" && {
            color: theme.palette.grey[700],
            "@media (hover: hover)": {
              "&:hover": {
                background: theme.palette.grey[100]
              }
            },
            "&:active, &:focus-visible": {
              background: theme.palette.grey[200]
            },
            [ICON_COLOR_VAR_NAME]: theme.palette.grey[700]
          }
        }
      };
    }
  },
  variants: [
    {
      props: { size: "xs" },
      style: {
        minWidth: 66,
        height: heightsSizeMap.xs,
        padding: "3px 6px",
        ".MuiButton-endIcon": {
          marginLeft: 3,
          marginRight: 0
        },
        ".MuiButton-startIcon": {
          marginRight: 3,
          marginLeft: 0
        },
        ".MuiButton-startIcon, .MuiButton-endIcon": {
          width: 12,
          height: 12,
          svg: {
            width: "100%",
            height: "auto"
          }
        }
      }
    },
    {
      props: { size: "sm" },
      style: {
        minWidth: 78,
        height: heightsSizeMap.sm,
        padding: "3px 12px",
        ".MuiButton-endIcon": {
          marginLeft: 6,
          marginRight: 0
        },
        ".MuiButton-startIcon": {
          marginRight: 6,
          marginLeft: 0
        },
        ".MuiButton-startIcon, .MuiButton-endIcon": {
          width: 12,
          height: 12
        }
      }
    },
    {
      props: { size: "md" },
      style: {
        minWidth: 90,
        height: heightsSizeMap.md,
        padding: "3px 12px",
        ".MuiButton-endIcon": {
          marginLeft: 6,
          marginRight: 0
        },
        ".MuiButton-startIcon": {
          marginRight: 6,
          marginLeft: 0
        },
        ".MuiButton-startIcon, .MuiButton-endIcon": {
          width: 18,
          height: 18
        }
      }
    },
    {
      props: { size: "lg" },
      style: {
        minWidth: 102,
        height: heightsSizeMap.lg,
        padding: "3px 16px",
        ".MuiButton-endIcon": {
          marginLeft: 6,
          marginRight: 0
        },
        ".MuiButton-startIcon": {
          marginRight: 6,
          marginLeft: 0
        },
        ".MuiButton-startIcon, .MuiButton-endIcon": {
          width: 18,
          height: 18
        }
      }
    },
    /** @deprecated 'xl' is deprecated */
    {
      props: { size: "xl" },
      style: {
        minWidth: 144,
        height: heightsSizeMap.xl,
        padding: "3px 24px",
        ".MuiButton-endIcon": {
          marginLeft: 6,
          marginRight: 0
        },
        ".MuiButton-startIcon": {
          marginRight: 6,
          marginLeft: 0
        },
        ".MuiButton-startIcon, .MuiButton-endIcon": {
          width: 24,
          height: 24
        }
      }
    },
    {
      props: { color: "secondary-light", variant: "contained" },
      style: ({ theme: t }) => ({
        background: alpha(t.palette.secondary.main, 7),
        [ICON_COLOR_VAR_NAME]: t.palette.secondary.main,
        "@media (hover: hover)": {
          "&:hover": {
            background: alpha(t.palette.secondary.main, 7),
            [ICON_COLOR_VAR_NAME]: t.palette.secondary.light
          }
        },
        "&:active": {
          background: alpha(t.palette.secondary.main, 7),
          [ICON_COLOR_VAR_NAME]: t.palette.secondary.dark
        }
      })
    },
    {
      props: { color: "secondary-light", variant: "outlined" },
      style: ({ theme: t }) => ({
        background: alpha(t.palette.secondary.main, 7),
        [ICON_COLOR_VAR_NAME]: t.palette.secondary.main,
        "@media (hover: hover)": {
          "&:hover": {
            background: alpha(t.palette.secondary.main, 7),
            [ICON_COLOR_VAR_NAME]: t.palette.secondary.light
          }
        },
        "&:active": {
          background: alpha(t.palette.secondary.main, 7),
          [ICON_COLOR_VAR_NAME]: t.palette.secondary.dark
        }
      })
    },
    {
      props: { color: "secondary-light", variant: "text" },
      style: ({ theme: t }) => ({
        background: alpha(t.palette.secondary.main, 7),
        [ICON_COLOR_VAR_NAME]: t.palette.secondary.main,
        "@media (hover: hover)": {
          "&:hover": {
            background: alpha(t.palette.secondary.main, 7),
            [ICON_COLOR_VAR_NAME]: t.palette.secondary.light
          }
        },
        "&:active": {
          background: alpha(t.palette.secondary.main, 7),
          [ICON_COLOR_VAR_NAME]: t.palette.secondary.dark
        }
      })
    },
    {
      props: { color: "black" },
      style: ({ theme: t }) => ({
        background: "transparent!important",
        [ICON_COLOR_VAR_NAME]: t.palette.grey[800],
        "@media (hover: hover)": {
          "&:hover": {
            background: "transparent",
            [ICON_COLOR_VAR_NAME]: t.palette.grey[700]
          }
        },
        "&.Mui-disabled": {
          background: "transparent"
        },
        "&:active": {
          background: "transparent",
          [ICON_COLOR_VAR_NAME]: t.palette.grey[900]
        }
      })
    }
  ],
  defaultProps: {
    variant: "contained",
    disableRipple: !0,
    size: "lg"
  }
};
export {
  buttonMuiThemeOverride
};
//# sourceMappingURL=buttonMuiThemeOverride.js.map
